<script lang="ts">
  import { Accordion, AccordionItem, CardBody, Col, Image } from "sveltestrap";
  import data from "../../../../Data/Users/Users.json"
  let imgPath:string = "/assets/images/social-app"

</script>
<Col xl="12" lg="6" md="12" sm="6" >
    <Accordion>
        <AccordionItem active header="Latest Photos">
            <CardBody class="photos filter-cards-view">
                <ul>
                    {#each data.userphotosdata as photoItem}
                        <li>
                            <div class="latest-post">
                                <Image fluid alt="" src="{imgPath}/{photoItem}" />
                            </div>
                        </li>
                    {/each}
                </ul>
            </CardBody>    
        </AccordionItem>
    </Accordion>
</Col>


  